import * as React from 'react';
import { makeStyles, Typography, useMediaQuery } from '@material-ui/core';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { ElementDimensions } from '../../styles/ElementDimensions';
import TextField, { TextFieldChangeHandler, TextFieldLabelPosition, TextFieldProps } from '../common/TextField';
import SplitProgress, { SplitProgressProps } from './SplitProgress'
import { CheckSummary } from '../../models/common/CheckSummary';
import { CheckStateContext } from '../../providers/CheckStateContextProvider';
import { CheckClaimSummary } from '../../models/common/CheckClaimSummary';
import themePrimary from '../../styles/themePrimary';
import { String_Split_SplitByPercentagePayLabel, String_Split_SplitByPercentageOfTotalBillLabel, 
    String_Split_SplitByPercentageClaimSummaryString } from '../../utilities/StringHelper';

const useStyles = makeStyles({
    innerContainer: {
        display: 'flex',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    outerContainer: {
        width: '100%',
        display: 'flex',
    },
    instructionText: {
        textAlign: 'center',
        marginLeft: ElementDimensions.margin5 + 'px',
        marginRight: ElementDimensions.margin5 + 'px',
        marginBottom: ElementDimensions.margin10 + 'px ',
    },
    root: {
        padding: ElementDimensions.padding20 + 'px',
        backgroundColor: themePrimary.palette.grey[100],
        width: '100%',
    },
    splitText1: {
        textAlign: 'right',
        marginRight:  ElementDimensions.margin10 + 'px ',
        lineHeight: '40px',
    },
    splitText2: {
        textAlign: 'left',
        marginLeft:  ElementDimensions.margin10 + 'px ',
        lineHeight: '40px',
    },
});

export type SplitByPercentageChangeHandler = (newValue: number) => any;

export interface SplitByPercentageProps {
    checkSummary: CheckSummary;
    claimSummary: CheckClaimSummary | null;
    onChangeHandler: SplitByPercentageChangeHandler;
}

const SplitByPercentage = (props: SplitByPercentageProps) => {
    const { checkSummary, claimSummary, onChangeHandler } = props;
    const isPortrait = true;
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const checkState = React.useContext(CheckStateContext);
    const [splitPercentage, setSplitPercentage] = React.useState<number>(0);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    const handleSplitPercentageTextChange: TextFieldChangeHandler = (newValue: string) => {
        let newPercentage: number = splitPercentage;

        if (newValue.trim() === '') {
            newPercentage = 0;
        }
        else {
            newPercentage = parseInt(newValue);
        }

        setSplitPercentage(newPercentage);
        onChangeHandler(newPercentage);
    };

    const splitPercentageTextFieldProps: TextFieldProps = {
        type: 'number_0_to_100',
        label: null,
        text: splitPercentage === 0 ? '' : splitPercentage.toString(),
        width: 80,
        disabled: false,
        labelPosition: TextFieldLabelPosition.None,
        onChangeHandler: handleSplitPercentageTextChange,
    }

    const splitProgressProps: SplitProgressProps = {
        progress: claimSummary !== null ? claimSummary.percent_unclaimed : 0,
        label: claimSummary !== null ? String_Split_SplitByPercentageClaimSummaryString(claimSummary.percent_unclaimed_string).find(s => s.key === userState.state.locale)!!.value : '',
    }

    return (
        <div className={classes.root}>
            <SplitProgress 
                progress={splitProgressProps.progress}
                label={splitProgressProps.label} />

            <div className={classes.outerContainer}>
                <div className={classes.innerContainer}>
                    <Typography variant="body1" className={classes.splitText1}>
                        {String_Split_SplitByPercentagePayLabel.find(s => s.key === userState.state.locale)!!.value}
                    </Typography>
                    <TextField 
                        type={splitPercentageTextFieldProps.type}
                        label={splitPercentageTextFieldProps.label}
                        text={splitPercentageTextFieldProps.text}
                        width={splitPercentageTextFieldProps.width}
                        disabled={splitPercentageTextFieldProps.disabled}
                        labelPosition={splitPercentageTextFieldProps.labelPosition}
                        onChangeHandler={splitPercentageTextFieldProps.onChangeHandler} />
                    <Typography variant="body1" className={classes.splitText2}>
                        {String_Split_SplitByPercentageOfTotalBillLabel.find(s => s.key === userState.state.locale)!!.value}
                    </Typography>
                </div>
            </div>
        </div>
    );
};

export default SplitByPercentage;
